import * as React from 'react';
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useParams, Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import {
    Box,
    Typography,
    CircularProgress,
    TextField
} from '@mui/material';

import axios from 'axios';
import { logout, getLocalToken } from '../utils';

const api = axios.create({
    baseURL: '/admin/api/v1',
});

api.interceptors.request.use((config) => {
    const token = getLocalToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default function Invites() {
    const { userId } = useParams();

    const location = useLocation();
    const referredBy = location.state?.referral;
    const userName = location.state?.userName;

    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [sortModel, setSortModel] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });

    const fetchInvites = useCallback(async () => {
        try {
            setLoading(true);

            const { page, pageSize } = paginationModel;
            const offset = page * pageSize;

            let query = `?offset=${offset}&limit=${pageSize}`;

            if (referredBy) {
                query += `&referredBy=${encodeURIComponent(referredBy)}`;
            }

            if (sortModel.length > 0) {
                const { field, sort } = sortModel[0];

                query += `&sort_by=${field}&sort_order=${sort}`;
            }

            const res = await api.get(`/users/${userId}/invites${query}`);

            const payload = res?.data?.payload || {};

            const items = (payload.items || []).map(user => ({
                ...user,
                name: `${user.first_name || ''} ${user.last_name || ''}`.trim()
            }));

            setRows(items);
            setTotalRows(payload.total || 0);

        } catch (err) {
            console.error(err);

            if (err.response?.status === 401) {
                logout();
            }
        } finally {
            setLoading(false);
        }
    }, [userId, referredBy, paginationModel, sortModel]);

    useEffect(() => {
        fetchInvites();
    }, [fetchInvites]);

    useEffect(() => {
        fetchInvites();
    }, [fetchInvites]);


    const columns = useMemo(() => [
        { field: 'email', headerName: 'Email', flex: 1, },
        { field: 'name', headerName: 'Name', flex: 1, },
        {
            field: 'plan_id',
            headerName: 'Subscription',
            width: 220,
            valueGetter: (value) => {
                return value ? value : 'N/A';
            }
        },
        {
            field: 'default_profile_type',
            headerName: 'Type',
            flex: 1,
            valueGetter: (value) => {
                if(value === 'dating' || value === 'friends'){
                    return 'social'
                }
                if(value === 'business'){
                    return 'business'
                }
                return 'N/A';
            }
        },
        {
            field: 'created',
            headerName: 'Created at',
            flex: 1,
            valueGetter: (value) => {
                if (!value) return 'N/A';
                const date = new Date(value);
                return date.toLocaleString(); //uses browser timezone
            }
        },
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            valueGetter: (value) => {
                if (!value) return 'N/A';
                return value ? value : 'N/A';
            }
        },
        {
            field: 'blocked_by_admin',
            headerName: 'Blocked',
            flex: 1,
            minWidth: 100,
            valueGetter: (value) => {
                return value ? 'Yes' : 'No';
            }
        },
    ]);
    console.log(rows)
    return (
        <>
            <br/>
            <DataGrid
                disableColumnMenu
                rows={rows}
                columns={columns}
                loading={loading}
                rowCount={totalRows}
                paginationMode="server"
                sortingMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                sortModel={sortModel}
                disableAutosize
                onSortModelChange={(model) => {
                    setSortModel(model);
                    setPaginationModel(prev => ({ ...prev, page: 0 }));
                }}
                pageSizeOptions={[25, 50, 100]}
                disableRowSelectionOnClick
                sx={{
                    border: 0,
                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                        outline: 'none',
                    },
                    '& .MuiDataGrid-cell:focus-visible': {
                        outline: 'none',
                    },
                }}
                slots={{
                    noRowsOverlay: () => (
                        <Box p={2}>No users found</Box>
                    )
                }}
            />
        </>
    );
}